import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	textContainer: {
		flex: 1
	}
})

export default useStyles
